import { APPLICATIONS_DETAILS, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";
import ShowCampaigns from "./Show";

export const resources = {
  isMenu: false,
  name: SpecialistServicePath + APPLICATIONS_DETAILS,
  custom: <ShowCampaigns />,
  permission: permissions.canPreviewSpecialistCampaignsApplications,
};
